import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpJsonService } from '../../services/http-json.service';

export interface SelectOption {
  text: string,
  value: string
}

@Component({
  selector: 'options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss']
})
export class OptionsComponent implements OnInit {

  //try to replace the select option with this:
  //https://devdactic.com/building-websites-ionic-4
  
  @Input() workoutType;
  @Output() onAllSelected = new EventEmitter();

  selectedWorkoutType: any;
  @Input() numberOfRounds: any;
  @Input() numberOfRoutinesPerRound: any;
  @Input() equipment: number[];

  roundNumbers: Array<SelectOption>;
  routines: Array<SelectOption>;
  equipmentUserHas: Array<SelectOption>;

  constructor() { }

  onSelectChanges(data) {
    // if (this.numberOfRounds && this.numberOfRoutinesPerRound && this.equipment) {
    if (this.numberOfRounds && this.numberOfRoutinesPerRound) {
      // if (this.selectedRoundNumber && this.selectedRoutinesNumber) {
      // console.log('selected equipment: ' + this.selectedEquipment);

      this.onAllSelected.emit({ rounds: this.numberOfRounds, routines: this.numberOfRoutinesPerRound, equipment: this.equipment });
    }
  }

  ngOnInit() {
    this.roundNumbers = new Array();

    for (let i = 1; i < 12; ++i) {
      this.roundNumbers.push({ text: i.toString(), value: i.toString() });
    }

    this.routines = new Array();

    for (let i = 1; i < 8; ++i) {
      this.routines.push({ text: i.toString(), value: i.toString() });
    }

    this.equipment = new Array();
    this.equipmentUserHas = new Array();

    let indxCnt = 0;
    HttpJsonService.mystuff.forEach(element => {
      this.equipmentUserHas.push({ text: element.text, value: element.value.toString() });
      indxCnt++;

    });
  }
}
